export { EstatePlanningBuyPaymentStep } from './Template/EstatePlanningBuyPayment';
